var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.996 11.739C19.8617 7.53586 16.4642 4.13842 12.2612 4.0042C9.97419 3.93164 7.83455 4.80214 6.25327 6.43475C4.73309 8.00424 3.93436 10.0733 4.00422 12.2612C4.13834 16.4642 7.53588 19.8617 11.7389 19.9958C11.8264 19.9986 11.9131 20 12 20C14.1852 20 16.2261 19.1353 17.7468 17.5653C19.267 15.9959 20.0658 13.9267 19.996 11.739ZM16.5367 16.3932C15.3361 17.6327 13.725 18.3153 12 18.3153C11.9311 18.3153 11.8621 18.3141 11.7926 18.312C8.47546 18.2061 5.79409 15.5247 5.68806 12.2075C5.63291 10.4797 6.26338 8.84588 7.46343 7.60696C8.66394 6.36747 10.2751 5.68489 12 5.68489C12.069 5.68489 12.138 5.68601 12.2075 5.68814C15.5246 5.79406 18.206 8.47544 18.312 11.7927C18.3672 13.5204 17.7366 15.1543 16.5367 16.3932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6247 11.5351L11.0771 8.99146C10.6987 8.72009 10.1719 8.99056 10.1719 9.45625V14.5437C10.1719 15.0094 10.6987 15.2799 11.0771 15.0085L14.6246 12.4647C14.9429 12.2366 14.9429 11.7634 14.6247 11.5351Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.283ede2e4c950d47b0001b149f64b7b7.svg";
export { ForwardRef as ReactComponent };